import React, { useState, useEffect } from "react";
import styles from "./Header.module.css";
import Search from "./Essentials/Search/Search";
import Explore from "./Essentials/Explore/Explore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faUserCircle, faArrowAltCircleRight } from "@fortawesome/free-regular-svg-icons";


const Header = ({ SelectedVertical, onVerticalSelect, HandleLogout, LoggedInUserProfilePhoto, LoggedInUserFullName, loading, isLoggedInUser }) => {
    const [toShowUserProfile, setToShowUserProfile] = useState(false);
    const [showLogoutButton, setShowLogoutButton] = useState(false);

    const HandleLoginClick = (Url) => {
        localStorage.setItem("dla_web_student_redirect_back_to_login", window.location.pathname);
        window.location = Url;
    };

    useEffect(() => {
        if (isLoggedInUser) {
            setToShowUserProfile(true);
        } else {
            setToShowUserProfile(false);
        }
    }, [isLoggedInUser]);

    const toggleLogoutButton = () => {
        setShowLogoutButton(!showLogoutButton);
    };

    return (
        <>
            {/* Top Strip */}
            <div className={styles.topStrip}>
                <a href="https://www.drishtiias.com" target="blank" className={styles.stripText}>
                    For any information Book Session
                    {/* <FontAwesomeIcon icon={faArrowAltCircleRight} className={styles.stripIcon} /> */}
                </a>
            </div>

            <div className={styles.headerContainer}>
                {/* Logo Section */}
                <div className={styles.headerLeft}>
                    <a href="/" className={styles.homeLink}>
                        <img src="/drishti_favicon.ico" alt="Logo" className={styles.headerLogo} />
                    </a>
                </div>

                {/* Middle Section: Search and Explore */}
                <div className={styles.headerMiddle}>
                    <Search SelectedVertical={SelectedVertical} onVerticalSelect={onVerticalSelect} />
                    <Explore />
                </div>

                {/* Right Section: Profile or Login */}
                <div className={styles.headerRight}>
                    {toShowUserProfile ? (
                        <div className={styles.profileContainer} onClick={toggleLogoutButton}>
                            {/* {LoggedInUserProfilePhoto ? <img className={styles.profilePhoto} src={LoggedInUserProfilePhoto} alt="User Profile" /> : <FontAwesomeIcon icon={faUserCircle} className={styles.defaultProfileIcon} />} */}
                            <span className={styles.profileText}>{LoggedInUserFullName || "User"}</span>
                            {showLogoutButton && (
                                <button onClick={HandleLogout} className={styles.logoutButton}>
                                    Logout
                                </button>
                            )}
                        </div>
                    ) : (
                        <button onClick={() => HandleLoginClick("/login")} className={styles.modernLoginButton}>
                            {/* <FontAwesomeIcon icon={faUserCircle} className={styles.loginIcon} /> */}
                            Login
                        </button>
                    )}
                </div>
            </div>
        </>
    );
};

export default Header;
